import { NgModule , CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsComponent } from './google-maps.component';
import { DirectivesModule } from '../../../directives/directives.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [ CommonModule, DirectivesModule, FormsModule],
  exports: [ GoogleMapsComponent ],
  declarations: [ GoogleMapsComponent ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class GoogleMapsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/google-maps/google-maps.module.ts